import React from "react";

const Java_Math = () => {
  return (
    <div>
      <h1>Java Math</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Math in Java.</p>
    </div>
  );
};

export default Java_Math;
